module.exports = __webpack_public_path__ + "img/check.3096e4ff.svg";